module.exports = __webpack_public_path__ + "img/red_plane_crossed.41d14971.svg";